var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChatAltFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.1194 5.58658C17.5 6.50544 17.5 7.67029 17.5 10C17.5 12.3297 17.5 13.4946 17.1194 14.4134C16.6119 15.6386 15.6386 16.6119 14.4134 17.1194C13.4946 17.5 12.3297 17.5 10 17.5H7.5C5.14298 17.5 3.96447 17.5 3.23223 16.7678C2.5 16.0355 2.5 14.857 2.5 12.5V10C2.5 7.67029 2.5 6.50544 2.8806 5.58658C3.38807 4.36144 4.36144 3.38807 5.58658 2.8806C6.50544 2.5 7.67029 2.5 10 2.5C12.3297 2.5 13.4946 2.5 14.4134 2.8806C15.6386 3.38807 16.6119 4.36144 17.1194 5.58658ZM6.5 8.33305C6.5 7.78077 6.94772 7.33305 7.5 7.33305H12.5C13.0523 7.33305 13.5 7.78077 13.5 8.33305C13.5 8.88534 13.0523 9.33305 12.5 9.33305H7.5C6.94772 9.33305 6.5 8.88534 6.5 8.33305ZM6.5 11.6664C6.5 11.1141 6.94772 10.6664 7.5 10.6664H10C10.5523 10.6664 11 11.1141 11 11.6664C11 12.2187 10.5523 12.6664 10 12.6664H7.5C6.94772 12.6664 6.5 12.2187 6.5 11.6664Z",
    fill: "#7161BA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatAltFill);
export default __webpack_public_path__ + "static/media/chat_alt_fill.37c96270ed86f845cf0e2e89beeebac6.svg";
export { ForwardRef as ReactComponent };